// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"xk-z","sponsoredTooltipWrapper":"yk-z","sponsoredTooltip":"zk-z","newCard":"Ak-z"};